module.exports = __webpack_public_path__ + "assets/img/2161591934007_.pic_hd.0ff7ee2f.jpg";